module.exports = __webpack_public_path__ + "img/image1.6d94c51c.png";